import React from "react";
import { ToastContainer } from "react-toastify";
import ViewBanner from "../../components/Settings/Banner/ViewBanner";

export const ViewBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewBanner />
        </div>
      </div>
    </div>
  );
};
